import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import CustomFieldID from '@/App/CustomField/Entity/CustomFieldID'
import ServiceID from '@/App/Service/Entity/ServiceID'
import {
    type CustomFieldData,
    type CustomFieldTypeEnum,
} from '@/Shared/AutoGenerated/Main'

export default class CustomField {
    constructor(
        public readonly id: CustomFieldID,
        public readonly type: CustomFieldTypeEnum,
        public readonly internalName: string,
        public readonly title: string,
        public readonly description: string | null,
        public readonly settings: any,
        public readonly isRequired: boolean,
        public readonly isEnabled: boolean,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: CustomFieldData): CustomField {
        return new CustomField(
            new CustomFieldID(entityData.id),
            entityData.type,
            entityData.internalName,
            entityData.title,
            entityData.description,
            entityData.settings,
            entityData.isRequired,
            entityData.isEnabled,
        )
    }

    static hydrateMultiple(entitiesData: CustomFieldData[]): CustomField[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
